import React from 'react';
import { useStateSelector } from 'src/redux';

interface Props {
  isActive?: boolean;
}
export const ReportCentre: React.FC<Props> = ({ isActive }) => {
  const colors = useStateSelector(({ theme }) => theme.colors);
  const fill = isActive ? 'url(#icon-gradient-rc)' : colors.cflowerBlue;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3226 0.25641C10.3226 0.188406 10.2954 0.123187 10.247 0.0751009C10.1986 0.0270146 10.133 0 10.0645 0H2.83871C2.08584 0 1.3638 0.29716 0.831439 0.826109C0.299077 1.35506 0 2.07247 0 2.82051V17.1795C0 17.9275 0.299077 18.6449 0.831439 19.1739C1.3638 19.7028 2.08584 20 2.83871 20H13.1613C13.9142 20 14.6362 19.7028 15.1686 19.1739C15.7009 18.6449 16 17.9275 16 17.1795V7.07385C16 7.00584 15.9728 6.94062 15.9244 6.89254C15.876 6.84445 15.8104 6.81744 15.7419 6.81744H11.0968C10.8914 6.81744 10.6945 6.73639 10.5493 6.59213C10.4041 6.44788 10.3226 6.25222 10.3226 6.04821V0.25641ZM10.0965 11.1938C10.2569 11.0663 10.4618 11.0072 10.666 11.0297C10.8703 11.0523 11.0571 11.1544 11.1855 11.3138C11.3139 11.4732 11.3734 11.6768 11.3507 11.8797C11.3281 12.0826 11.2252 12.2683 11.0648 12.3959L8.49032 14.4421C8.35246 14.5539 8.18003 14.6151 8.00206 14.6154H7.99381C7.81905 14.6141 7.64988 14.5541 7.51381 14.4451L4.93626 12.3959C4.77583 12.2685 4.67292 12.0829 4.65017 11.8801C4.62743 11.6773 4.68671 11.4738 4.81497 11.3144C4.94323 11.155 5.12997 11.0527 5.33411 11.0301C5.53824 11.0075 5.74305 11.0664 5.90348 11.1938L7.22581 12.2462V8.71795C7.22581 8.61693 7.24583 8.5169 7.28474 8.42358C7.32365 8.33025 7.38067 8.24545 7.45256 8.17402C7.52445 8.10259 7.6098 8.04593 7.70373 8.00727C7.79766 7.96862 7.89833 7.94872 8 7.94872C8.10167 7.94872 8.20234 7.96862 8.29627 8.00727C8.3902 8.04593 8.47555 8.10259 8.54744 8.17402C8.61933 8.24545 8.67635 8.33025 8.71526 8.42358C8.75417 8.5169 8.77419 8.61693 8.77419 8.71795V12.2462L10.0965 11.1938Z"
        fill={fill}
      />
      <defs>
        <linearGradient
          id="icon-gradient-rc"
          x1="0"
          y1="0"
          x2="19.2891"
          y2="4.45738"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0001" stopColor={colors.gp1} />
          <stop offset="1" stopColor={colors.gp2} />
        </linearGradient>
      </defs>
    </svg>
  );
};
